module.exports = __webpack_public_path__ + "static/img/Group393.5a2c79a.png";


//////////////////
// WEBPACK FOOTER
// ./src/newpage/static/images/service-mode/Group393.png
// module id = y27K
// module chunks = 1